import React from "react";
import DatePickerInner from './DatePickerInner';

export default class EmptyPage extends React.Component {

  

    handleChange(event) {
    }

    componentDidUpdate(prevProps) {
    }

    getDate(){
        return this.state.value;
    }

    render (){

        return ( 
        <div style={mainClass}>
            <div style={message} >You have to select an event first</div>
        </div>
        )
    }


}

const mainClass = {
    width: '100%',
    height: '100%',
}

const message = {
    textAlign: 'center',
    top: '30%',
    position: 'relative',
    
}

const inputText = {
    width: '300px',
    padding: '10px'
}